import { ReactNode } from 'react';
import classNames from 'classnames';

type ContainerProps = {
  children: ReactNode;
  className?: string;
};

function Container(props: ContainerProps) {
  return <div className={classNames('container m-auto', props.className)}>{props.children}</div>;
}

export default Container;
